'use client';

import Link from 'next/link';

// import { SmartFormattedMessage } from '@/components/smart-formatted-message';

export default function NotFound() {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="space-y-4 text-center">
        <h1 className="text-xl font-semibold">
          404 - Not Found
          {/* <SmartFormattedMessage
            defaultMessage="404 - Not Found"
            description="Page title for 404 not found page"
          /> */}
        </h1>
        <p className="text-muted-foreground">
          {/* <SmartFormattedMessage
            defaultMessage="Could not find requested resource"
            description="Message explaining that the requested resource could not be found"
          /> */}
          Could not find requested resource
        </p>
        <div>
          <Link href="/" className="text-primary">
            {/* <SmartFormattedMessage
              defaultMessage="Return Home"
              description="Link text to go back to the home page"
            /> */}
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}
